import QuotationsService from '@/services/resources/quotations.service';
import statesMixin from './statesMixin';
import { mapState } from 'vuex';

export default {
  mixins: [statesMixin],
  computed: {
    ...mapState('models/quotation', ['states']),
    isQuotationOpen() {
      return this.checkStatus(QuotationsService._STATE_OPEN);
    },
    isQuotationCreated() {
      return this.checkStatus(QuotationsService._STATE_CREATED);
    },
    isQuotationSended() {
      return this.checkStatus(QuotationsService._STATE_SENDED);
    },
  },
  mounted() {
    this.statesColors = this.$services.resource('quotation_states').getColors();
  },
  data() {
    return {
      statesColors: [],
    };
  },
  methods: {
    getColor(quotation) {
      return this.statesColors[quotation.state.id - 1];
    },
    checkStatus(status) {
      return this.quotation.state && this.quotation.state.name === status;
    },
    setNewState(state) {
      this.quotation.state = state;
    },
  },
};
